// Seta da casa de dica na cruzada direta: deriva da posição da palavra (x = coluna,
// y = linha) em relação à casa de dica (row, column). Pura para poder ser testada.
export interface ArrowWord {
  x: number;
  y: number;
  direcao: number;
}

export interface ArrowCell {
  palavra_1: ArrowWord | -1;
  palavra_2: ArrowWord | -1;
}

export function getArrow(obj: ArrowCell, row: number, column: number): string | undefined {

  if (obj.palavra_1 !== -1 && obj.palavra_2 === -1) {
    if (obj.palavra_1.x > column) {
      if (obj.palavra_1.direcao === 0) {
        return 'arrow_left';
      }
      return 'curved_arrow_left';
    } if (obj.palavra_1.y > row) {
      if (obj.palavra_1.direcao === 1) {
        return 'arrow_bottom';
      }
      return 'curved_arrow_bottom';
    } if (obj.palavra_1.y < row) {
      if (obj.palavra_1.direcao === 0) {
        return 'arrow_left_cima';
      }
    // palavra começa à ESQUERDA da dica (x = coluna) e desce
    } else if (obj.palavra_1.x < column) {
      if (obj.palavra_1.direcao === 1) {
        return 'arrow_bottom_lado';
      }
    }
  } else if (obj.palavra_1 === -1 && obj.palavra_2 !== -1) {
    if (obj.palavra_2.x > column) {
      if (obj.palavra_2.direcao === 0) {
        return 'arrow_left';
      }
      return 'curved_arrow_left';
    }

    if (obj.palavra_2.y > row) {
      if (obj.palavra_2.direcao === 1) {
        return 'arrow_bottom';
      }
      return 'curved_arrow_bottom';
    }

    if (obj.palavra_2.y < row) {
      if (obj.palavra_2.direcao === 0) {
        return 'arrow_left_cima';
      }
    // palavra começa à ESQUERDA da dica (x = coluna) e desce
    } else if (obj.palavra_2.x < column) {
      if (obj.palavra_2.direcao === 1) {
        return 'arrow_bottom_lado';
      }
    }
  } else if (obj.palavra_1 !== -1 && obj.palavra_2 !== -1) {
    let classe = '';

    if (obj.palavra_1.x > column) {
      if (obj.palavra_1.direcao === 0) {
        classe += 'arrow_left ';
      } else {
        classe += 'curved_arrow_left ';
      }
    }

    if (obj.palavra_1.x < column) {
      if (obj.palavra_1.direcao === 0) {
        classe += 'arrow_back ';
      } else {
        classe += 'curved_arrow_back ';
      }
    }

    if (obj.palavra_1.y < column && obj.palavra_1.x === row) {
      if (obj.palavra_1.direcao === 1) {
        classe += 'arrow_bottom_lado ';
      }
    }

    if (obj.palavra_1.y > row) {
      if (obj.palavra_1.direcao === 1) {
        classe += 'arrow_bottom ';
      } else {
        classe += 'curved_arrow_bottom ';
      }
    }

    if (obj.palavra_1.y < row) {
      if (obj.palavra_1.direcao === 0) {
        classe += 'arrow_left_cima ';
      }
    }

    if (obj.palavra_2.x > column) {
      if (obj.palavra_2.direcao === 0) {
        classe += 'arrow_left ';
      } else {
        classe += 'curved_arrow_left ';
      }
    }

    if (obj.palavra_2.y < column && obj.palavra_1.x === row) {
      if (obj.palavra_2.direcao === 1) {
        classe += 'arrow_bottom_lado ';
      }
    }

    if (obj.palavra_2.y > row) {
      if (obj.palavra_2.direcao === 1) {
        classe += 'arrow_bottom ';
      } else {
        classe += 'curved_arrow_bottom ';
      }
    }

    if (obj.palavra_2.y < row) {
      if (obj.palavra_2.direcao === 0) {
        classe += 'arrow_left_cima ';
      }
    }
    return classe;
  }
}
